import type { LoginResult } from "authentication/js/api/login.api";
import type { Ref } from "vue";
import { loginWithCredentials, loginWithToken } from "authentication/js/api/login.api";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useLoginStore = defineStore("feature/authentication/login", () => {
  const latestLoginResult = ref({}) as Ref<LoginResult>;

  const getLatestLoginResult = computed(() => latestLoginResult.value);

  const loginSuccess = computed(() => latestLoginResult.value?.loginStatus === "SUCCESS");
  const loginFailure = computed(() => latestLoginResult.value?.loginStatus === "FAILURE");
  const tokenNotFound = computed(() => latestLoginResult.value?.loginFailure?.failureReason === "NOT_FOUND");
  const retryLimitExceeded = computed(() => latestLoginResult.value?.loginFailure?.failureReason === "RETRY_LIMIT_EXCEEDED");

  async function handleLoginWithCredentials(username: string, password: string) {
    latestLoginResult.value = await loginWithCredentials(username, password);
  }

  async function handleLoginWithToken(token: string) {
    latestLoginResult.value = await loginWithToken(token);
  }

  return {
    latestLoginResult,
    getLatestLoginResult,
    handleLoginWithCredentials,
    handleLoginWithToken,
    loginSuccess,
    loginFailure,
    tokenNotFound,
    retryLimitExceeded,
  };
});
